// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// https://firebase.google.com/docs/web/setup#available-libraries
//
// CRA inlines only *direct* `process.env.REACT_APP_*` references. Do not read these via a dynamic key.

const isJest =
  typeof process !== "undefined" &&
  (process.env.NODE_ENV === "test" || !!process.env.JEST_WORKER_ID);

const missingFirebaseEnvMessage =
  "Missing Firebase web config for the appointments app. Create apps/appointments/.env.local from .env.example.\n" +
  "Use the same Firebase project as the volunteer app: copy apps/volunteer/.env.local and rename each key from VITE_FIREBASE_* to REACT_APP_FIREBASE_*.\n" +
  "See apps/appointments/ENV_HANDOFF.md";

let firebaseConfig;

if (isJest) {
  firebaseConfig = {
    apiKey: "jest-placeholder-api-key",
    authDomain: "jest-placeholder.firebaseapp.com",
    projectId: "jest-placeholder",
    storageBucket: "jest-placeholder.appspot.com",
    messagingSenderId: "000000000000",
    appId: "1:000000000000:web:0000000000000000000000",
    measurementId: undefined,
  };
} else {
  const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
  const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  const rawStorageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
  const messagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
  const appId = process.env.REACT_APP_FIREBASE_APP_ID;
  const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

  const required = {
    REACT_APP_FIREBASE_API_KEY: apiKey,
    REACT_APP_FIREBASE_AUTH_DOMAIN: authDomain,
    REACT_APP_FIREBASE_PROJECT_ID: projectId,
    REACT_APP_FIREBASE_STORAGE_BUCKET: rawStorageBucket,
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID: messagingSenderId,
    REACT_APP_FIREBASE_APP_ID: appId,
  };

  const empty = Object.entries(required).filter(
    ([, v]) => typeof v !== "string" || !v.trim()
  );
  if (empty.length) {
    throw new Error(
      `${missingFirebaseEnvMessage}\nMissing or empty: ${empty.map(([k]) => k).join(", ")}`
    );
  }

  const pid = projectId.trim();
  const rawBucket = rawStorageBucket.trim();
  const storageBucket =
    rawBucket === `${pid}.appspot.com` ? `${pid}.firebasestorage.app` : rawBucket;

  firebaseConfig = {
    apiKey: apiKey.trim(),
    authDomain: authDomain.trim(),
    projectId: pid,
    storageBucket,
    messagingSenderId: messagingSenderId.trim(),
    appId: appId.trim(),
    measurementId:
      typeof measurementId === "string" && measurementId.trim()
        ? measurementId.trim()
        : undefined,
  };
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firestore
const db = getFirestore(app);

export { app, db }; // export both the app and db instances
